module.exports = __webpack_public_path__ + "static/media/arvel-crynyd.848bc9df.jpg";